import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiList, getCancelData } from '../api/callAPI';
import useUser from '../hook/useUser';
import useCancel from '../hook/useCancel';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import { presetExcelSheets } from '../utils/GoogleFieldsDefined';

import _ from 'lodash'
import axios from 'axios';

const useGoogleFieldsData = () => {
  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const [isLoading, setIsLoading] = useState(true);
  const [googleDefinition, setGoogleDefinition] = useState([]);
  const { cancelData, setCancelData } = useCancel();
  const [isLoadingData, setIsLoadingData] = useState(false);

  const fetchColumnDefinition = () => {

    let fieldsDefined;

    fieldsDefined = apiList.googleDefinition({})

      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

        if (res.status === 200) {
          console.log('googleDefinition-res', res);
          setGoogleDefinition(res.data);
          setIsLoading(false);
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  // useEffect(() => {
  //   fetchColumnDefinition();
  // }, [])

  // console.log('fieldsData',fieldsData);
 
  //排序欄位
  const fieldsSort = googleDefinition.sort((a, b) => {
    return a.index - b.index;
  });

  //--------------------------------------------------------資料層(回傳格式)-------------------------------------------------

  //一般欄位
  const generalData = fieldsSort
    .filter((el) => el.categoryId === "default" || el.categoryId === "select" && el.isDimension === false)
    .map((edition, index) => {
      return {
        name: edition.name,
        name_eng: edition.name_eng,
        expression: edition.id,
        format: edition.format,
        type: edition.type,
        sheet: edition.sheet,
      }
    })

  //所有轉換、轉換欄位sheet預設為[]
  const conversionsData = fieldsSort
    .filter((el) => el.categoryId === "all_conversions" || el.categoryId === "conversions")
    .map((edition, index) => {
      return {
        name: edition.name,
        name_eng: edition.name_eng,
        expression: edition.id,
        format: edition.format,
        type: edition.type,
        sheet: edition.sheet,
      }
    })

  //所有轉換欄位sheet加上全部頁籤
  const tickAllConversionsData = JSON.parse(JSON.stringify(conversionsData))
  // tickAllConversionsData[5].sheet = presetExcelSheets;
  // tickAllConversionsData[6].sheet = presetExcelSheets;
  // tickAllConversionsData[7].sheet = presetExcelSheets;

  //轉換欄位sheet加上全部頁籤
  const tickConversionsData = JSON.parse(JSON.stringify(conversionsData))
  // tickConversionsData[0].sheet = presetExcelSheets;
  // tickConversionsData[1].sheet = presetExcelSheets;
  // tickConversionsData[2].sheet = presetExcelSheets;
  // tickConversionsData[3].sheet = presetExcelSheets;
  // tickConversionsData[4].sheet = presetExcelSheets;

  // console.log("generalData",generalData);
  // console.log("conversionsData",conversionsData);
  // console.log("tickAllConversionsData",tickAllConversionsData);

  //--------------------------------------------------------顯示層--------------------------------------------------------

  //一般欄位(預設+自選)
  const generalFields = Array.from(
    new Set(
      fieldsSort.filter(
        (el) => el.categoryId === "default" || el.categoryId === "select" && el.isDimension === false
      ).map((s) => (s.categoryName = "一般"))
    )
  ).map((label, index) => {
    return {
      category: `${label}_${index}`,
      name: label,
      child: fieldsSort.filter((s) => s.categoryName === label).map(
        (edition) => {
          return {
            name: edition.name,
            name_eng: edition.name_eng,
            expression: edition.id,
            format: edition.format,
            type: edition.type,
            sheet: edition.sheet,
          };
        }
      )
    };
  });

  //所有轉換
  const allConversionsFields = Array.from(new Set(fieldsSort
    .filter((el) => el.categoryId === "all_conversions")
    .map((s) => s.categoryName))).map(
      (lab, index) => {
        return {
          category: `${lab}_${index}`,
          name: lab,
          child: fieldsSort
            .filter((el) => el.categoryId === "all_conversions")
            .map((edition) => {
              return {
                name: edition.name,
                name_eng: edition.name_eng,
                expression: edition.id,
                format: edition.format,
                type: edition.type,
                sheet: edition.sheet,
              };
            })
        };
      }
    );

  //轉換
  const conversionsFields = Array.from(new Set(fieldsSort
    .filter((el) => el.categoryId === "conversions")
    .map((s) => s.categoryName))).map(
      (lab, index) => {
        return {
          category: `${lab}_${index}`,
          name: lab,
          child: fieldsSort
            .filter((el) => el.categoryId === "conversions")
            .map((edition) => {
              return {
                name: edition.name,
                name_eng: edition.name_eng,
                expression: edition.id,
                format: edition.format,
                type: edition.type,
                sheet: edition.sheet,
              };
            })
        };
      }
    );

  //把資料回傳出去
  return [
    googleDefinition,
    // generalData,
    // conversionsData,
    // tickAllConversionsData,
    // tickConversionsData,
    // generalFields,
    // allConversionsFields,
    // conversionsFields,
  ];

};

export default useGoogleFieldsData;